function pxToRem(pxValue, rootFontSize = 75) {
    return `${pxValue / rootFontSize}rem`;
}

const defaultIcon = [
    { title: "补差说明", icon: "https://qiniu-cdn6.jinxidao.com/group1/2024/11/28/18/14/30966674842971f5bf.png" },
    { title: "套餐包含", icon: "https://qiniu-cdn6.jinxidao.com/group1/2024/11/28/18/15/78559674842c2878c4.png" },
    { title: "套餐不包含", icon: "https://qiniu-cdn6.jinxidao.com/group1/2024/11/28/18/16/56599674842eb97b22.png" },
    { title: "特别说明", icon: "https://qiniu-cdn6.jinxidao.com/group1/2024/11/28/18/17/193636748432766484.png" },
    { title: "使用规则", icon: "https://qiniu-cdn6.jinxidao.com/group1/2024/11/28/18/17/45428674843514bd5c.png" },
    { title: "时间说明", icon: "https://qiniu-cdn6.jinxidao.com/group1/2024/12/02/09/59/1309674d14984882d.png" },
    { title: "订房说明", icon: "https://qiniu-cdn6.jinxidao.com/group1/2024/11/29/18/41/8293367499a734b4ce.png" },
    { title: "预约说明", icon: "https://qiniu-cdn6.jinxidao.com/group1/2024/11/29/18/41/8293367499a734b4ce.png" }
];

const li_tagBegin = "<div style=\""
    + "width:100%;"
    + "display: flex;"
    + "flex-direction:row;"
    + "justify-content:flex-start;"
    + "align-items:flex-start;"
    + "overflow-x:hidden;"
    + "box-sizing:border-box;"
    + "padding-left:li_padding_left_place_holder;"
    + "padding-right:0px;"
    + "\">"
    + `<div style=\"display:block;padding-top:${pxToRem(16)};margin-right:${pxToRem(16)};\">`
    + `<div style=\"display:block;width:${pxToRem(10)};height:${pxToRem(10)};background-color:#999999;border-radius:50%;\"></div>`
    + "</div>"
    + "<div style=\"display:block;min-width:97%;max-width:97%;position:relative;margin-top:0px;li_bg_place_holder\">";


const li_tagEnd = "</div></div>";

const ul_tagBegin = "<div style=\""
    + "width:100%;"
    + "padding-left:0px;"
    + "padding-right:0px;"
    + "overflow-x:hidden;"
    + "box-sizing:border-box;"
    + "margin-bottom:0px;"
    + "\">";

const ul_tagEnd = "</div>";

const custom_tblk_icon = "<img style=\""
    + "display:block;"
    + `width:${pxToRem(30)};`
    + `min-width:${pxToRem(30)};`
    + `height:${pxToRem(30)};`
    + `min-height:${pxToRem(30)};`
    + "position:relative;"
    + "\" src=\"custom_tblk_icon_src_place_holder\""
    + "/>"

const default_tblk_icon = "<div style=\""
    + "display: flex;"
    + "flex-direction: row;"
    + "justify-content: center;"
    + "align-items: center;"
    + `width:${pxToRem(30)};`
    + `min-width:${pxToRem(30)};`
    + `height:${pxToRem(30)};`
    + `min-height:${pxToRem(30)};`
    + "position:relative;\">"
    + "<div style=\""
    + "display:block;"
    + `width:${pxToRem(20)};`
    + `min-width:${pxToRem(20)};`
    + `height:${pxToRem(20)};`
    + `min-height:${pxToRem(20)};`
    + "background-color:#fff;"
    + "border-radius:50%;"
    + `border: ${pxToRem(6)} solid #999999;`
    + "position:relative;"
    + "\">"
    + "</div>"
    + "</div>"

// const tblk_tagBegin = "<div style=\""
//     //+"font-size:0.8em;"
//     + "font-family: PingFang SC, PingFang SC;"
//     + "font-weight: bold;"
//     + "color: #333333;"
//     + "padding-left:0px;"
//     + "padding-right:0px;"
//     + "overflow-x:hidden;"
//     + "box-sizing:border-box;"
//     + "display: flex;"
//     + "flex-direction: row;"
//     + "justify-content: flex-start;"
//     + "align-items: flex-start;"
//     + "margin-top:0px;"
//     + "tblk_bg_place_holder"
//     + "\">"
//     + "<div style=\""
//     + "display:block;"
//     + `width:${pxToRem(24)};`
//     + `min-width:${pxToRem(24)};`
//     + `height:${pxToRem(24)};`
//     + `min-height:${pxToRem(24)};`
//     + "background-color:#FFF;"
//     + "border-radius:50%;"
//     + `border:${pxToRem(7)} solid #999999;`
//     + "position:relative;"
//     + `margin-top:${pxToRem(8)};`
//     + "\">"
//     + "</div>"
//     + `<div style=\"display:block;width:${pxToRem(12)};height:${pxToRem(4)};\"></div>`
//     + "<div";

const tblk_tagBegin = "<div style=\""
    + "font-family: PingFang SC, PingFang SC;"
    + "font-weight: bold;"
    + "color: #333333;"
    + "padding-left:0px;"
    + "padding-right:0px;"
    + "overflow-x:hidden;"
    + "box-sizing:border-box;"
    + "display: flex;"
    + "flex-direction: row;"
    + "justify-content: flex-start;"
    + "align-items: center;"
    + "margin-top:0px;"
    + "tblk_bg_place_holder"
    + "\">"
    + "tblk_icon_place_holder"
    + `<div style=\"display:block;width:${pxToRem(10)};height:${pxToRem(4)};\"></div>`
    + "<div";

const tblk_tagEnd = "</div></div>";


const pblk_tagBegin = "<div style=\""
    + "width:100%;"
    + "padding-left:pblk_padding_left_place_holder;"
    + "padding-right:0px;"
    + "overflow-x:hidden;"
    + "overflow-y:hidden;"
    + "box-sizing:border-box;"
    + "white-space:normal;word-break:break-word;"
    + "pblk_bg_place_holder"
    + "\">";

const pblk_tagEnd = "</div>";

const root_tagBegin = "<div style=\""
    + `font-size:${pxToRem(26)};`
    + "font-family: PingFang SC, PingFang SC;"
    + "font-weight: 400;"
    + "color: #666666;"
    //+"line-height: 1.0em;"
    + "width:100%;"
    + "box-sizing:border-box;"
    + "padding-left:root_padding_left_place_holder;"
    + "padding-right:0px;"
    + "line-height:1.5;"
    + "\">";

const root_tagEnd = "</div>";

const mtp_tagBegin = "<div style=\""
    + `width:${pxToRem(10)};`
    + `height:${pxToRem(20)};`
    + "mtp_bg_place_holder"
    + "\">";


const mtt_tagBegin = "<div style=\""
    + `width:${pxToRem(10)};`
    + `height:${pxToRem(30)};`
    + "mtt_bg_place_holder"
    + "\">";

const STYLE_CSS_NEW = "<head><style>img{max-width: 100%;text-align: center;}</style></head><body>";

const root_padding_left = "0px";
const li_padding_left = "0px";


const net_fail_msg = '网络好像有点问题，请稍后再试...'


/**
 * 
 * @param {string} rawInput 格式化的内容
 * @param {boolean} liNoDot 是否需要圆点  true不需要 false需要
 * 
 */

export function lolila_2_nanuli_core(rawInput, liNoDot, containerWidth) {
    return new Promise(function (resolve, reject) {
        var pblk_padding_left = pxToRem(32);

        var _is_empty_str = (str) => {
            if (str == null || str.length == 0) {
                return true;
            }
            return false;
        }

        var _replaceAll = (str, src, dec) => {
            return str.split(src).join(dec);
        }

        var _req_covert = function (input = "") {
            return new Promise((resolve, reject) => {
                const params = {
                    text: input,
                    platform: "douyin-miniapp",
                    containerWidthPx: containerWidth||400,
                };

                $.ajax({
                    url: 'https://presale.yaochufa.com/product/convertText',
                    type: 'POST',
                    contentType: 'application/json',
                    data: JSON.stringify(params),
                    success: (res) => {
                        resolve(res);
                    },
                    error: () => {
                        reject(net_fail_msg);
                    }
                });
            });
        };


        if (_is_empty_str(rawInput)) {
            resolve(rawInput);
            return;
        }

        _req_covert(rawInput).then(res => {
            if (res.code != 1000) {
                resolve(rawInput);
                return;
            }
            rawInput = res.content.text || "";


            var li_bg_place_holder = "";
            var pblk_bg_place_holder = "";
            var tblk_bg_place_holder = "";
            var mtt_bg_place_holder = "";
            var mtp_bg_place_holder = "";

            var renderDebugBg = false
            if (renderDebugBg) {
                li_bg_place_holder = "background-color:#efefdc;";
                pblk_bg_place_holder = "background-color:#00FF23;";
                tblk_bg_place_holder = "background-color:#d3d4d5;";
                mtt_bg_place_holder = "background-color:#FF1900;";
                mtp_bg_place_holder = "background-color:#0000FF;";
            }


            // 去掉所有字体大小
            rawInput = _replaceAll(rawInput, "font-size", "suck-size");
            // 去掉所有行高
            rawInput = _replaceAll(rawInput, "line-height", "suck-height");
            // 去掉所有字体样式
            rawInput = _replaceAll(rawInput, "font-family", "suck-family");
            //
            rawInput = _replaceAll(rawInput, "margin", "suck");


            //
            rawInput = _replaceAll(rawInput, "<nanu-ul>", ul_tagBegin);
            rawInput = _replaceAll(rawInput, "</nanu-ul>", ul_tagEnd);

            //
            if (liNoDot) {
                pblk_padding_left = "0rpx";
                rawInput = _replaceAll(rawInput, "<nanu-li>", "<div style=\"width:100%;\">")
                rawInput = _replaceAll(rawInput, "</nanu-li>", "</div>");
            } else {
                rawInput = _replaceAll(rawInput, "<nanu-li>", li_tagBegin)
                rawInput = _replaceAll(rawInput, "</nanu-li>", li_tagEnd);
            }

            defaultIcon.forEach(cfg => {
                let title = cfg.title;
                let iconSrc = cfg.icon;
                const custom_tblk_icon_of_this_title = _replaceAll(custom_tblk_icon,"custom_tblk_icon_src_place_holder",iconSrc)
                const custom_tblk_tagBegin_of_this_title =  _replaceAll(tblk_tagBegin,"tblk_icon_place_holder",custom_tblk_icon_of_this_title)
                const rpt = "<nanu-tblk rpt=\""+title+"\""
                rawInput = _replaceAll(rawInput, rpt, custom_tblk_tagBegin_of_this_title );
     
            })
           // // 处理剩下的没有匹配的标题
			const def_tblk_icon_2 = _replaceAll(custom_tblk_icon,"custom_tblk_icon_src_place_holder","https://qiniu-cdn6.jinxidao.com/group1/2025/01/16/16/52/720046788c8d570237.png")
			const default_tblk_tagBegin = _replaceAll(tblk_tagBegin,"tblk_icon_place_holder",def_tblk_icon_2)
			//const default_tblk_tagBegin = _replaceAll(tblk_tagBegin,"tblk_icon_place_holder",default_tblk_icon)
			rawInput = _replaceAll(rawInput, "<nanu-tblk", default_tblk_tagBegin );
			// 处理所有TBLK闭合标签
			rawInput = _replaceAll(rawInput, "</nanu-tblk>",tblk_tagEnd );


            //
            rawInput = _replaceAll(rawInput, "<nanu-pblk>", pblk_tagBegin)
            rawInput = _replaceAll(rawInput, "</nanu-pblk>", pblk_tagEnd);

            //
            rawInput = _replaceAll(rawInput, "<nanu-mtp>", mtp_tagBegin);
            rawInput = _replaceAll(rawInput, "</nanu-mtp>", "</div>");

            //
            rawInput = _replaceAll(rawInput, "<nanu-mtt>", mtt_tagBegin);
            rawInput = _replaceAll(rawInput, "</nanu-mtt>", "</div>");

            rawInput = _replaceAll(rawInput, "li_padding_left_place_holder", li_padding_left)
            rawInput = _replaceAll(rawInput, "pblk_padding_left_place_holder", pblk_padding_left)
            rawInput = _replaceAll(rawInput, "li_bg_place_holder", li_bg_place_holder)
            rawInput = _replaceAll(rawInput, "mtt_bg_place_holder", mtt_bg_place_holder)
            rawInput = _replaceAll(rawInput, "mtp_bg_place_holder", mtp_bg_place_holder)
            rawInput = _replaceAll(rawInput, "pblk_bg_place_holder", pblk_bg_place_holder)
            rawInput = _replaceAll(rawInput, "tblk_bg_place_holder", tblk_bg_place_holder)

            rawInput = STYLE_CSS_NEW
                + _replaceAll(root_tagBegin, "root_padding_left_place_holder", root_padding_left)
                + rawInput
                + root_tagEnd
                + "</body>";

            resolve(rawInput);
        }).catch(err => {
            console.log("###fuck", err);
            reject(err);
        });
    });
};